import appConstants from '../config/constants';
import appConfig from '../config/config';

export default {
  data() {
    return {
      isMixins: true,
      hideUi: false, // for the use of dialog,
      allAssetsLoaded: false, // used for showing page only when all assets have rendered,
      activeViewId: '',
      lastActivatedBtn: '',
      itemLoaded: 0
    };
  },
  watch: {
    itemLoaded(newVal, oldVal) {
      const activeView = document.getElementById(this.activeViewId);
      if (activeView) {
        const itemsToLoad = this.getItemsToLoad(activeView);
        // console.log(`items to load: ${itemsToLoad}`);
        if (newVal === itemsToLoad) {
          this.allAssetsLoaded = true;
        }
      }
    }
  },
  methods: {
    getItemsToLoad(activeView) {
      // console.log({
      //   imgs: activeView.getElementsByTagName('img'),
      //   audio: activeView.getElementsByTagName('audio')
      // });

      return (
        activeView.getElementsByTagName('img').length +
        activeView.getElementsByTagName('audio').length
      );
    },
    getBtnClasses() {
      return this.btnClasses;
    },
    collectHoverableButtonsData() {
      if (!this.$el.querySelectorAll && !this.$el.getBoundingClientRect) {
        return [];
      }
      let hoverableButtonEls = this.$el.querySelectorAll('.hoverable-button');
      let hoverableButtonsData = [];
      const {
        left: parentLeft,
        top: parentTop
      } = this.$el.getBoundingClientRect();
      for (let hovBtnEl of hoverableButtonEls) {
        const buttonAbsoluteRect = hovBtnEl.getBoundingClientRect();

        // Converting the coordinates to be relative to the parent div, and not to the screen
        const buttonRelativeRect = {
          left: buttonAbsoluteRect.left - parentLeft,
          top: buttonAbsoluteRect.top - parentTop,
          right: buttonAbsoluteRect.right - parentLeft,
          bottom: buttonAbsoluteRect.bottom - parentTop,
          yMitigator: (buttonAbsoluteRect.height * 1) / 6,
          xMitigator: (buttonAbsoluteRect.width * 1) / 6
          // mitigators reduce accuracy but make it easier to 'click' a btn - they make the item's hover space 'bigger' than it actually is.
        };

        let hoverableButtonDataObj = {
          rect: buttonRelativeRect,
          handlerId: hovBtnEl.getAttribute('handler-id')
        };
        if (!this.hideUi) {
          hoverableButtonsData.push(hoverableButtonDataObj);
        } else if (
          hoverableButtonDataObj.handlerId === appConstants.yes ||
          hoverableButtonDataObj.handlerId === appConstants.no
        ) {
          hoverableButtonsData.push(hoverableButtonDataObj);
        }
      }
      return hoverableButtonsData;
    },
    resetBtnClasses() {
      for (const btnCssClass in this.btnClasses) {
        this.btnClasses[btnCssClass] = '';
      }
    },
    handleHoverEvent(handlerId) {
      this.resetBtnClasses();
      this.btnClasses[handlerId] = appConstants.hover;
      // this.setHoverSpinner(handlerId);
    },
    handleActivateEvent(handlerId) {
      this.resetBtnClasses();
      this.btnClasses[handlerId] = appConstants.activate;
      if (handlerId === appConstants.back) {
        this.handleActivateBack();
        return;
      }
      if (this.handleActivateEventInComponent) {
        this.handleActivateEventInComponent(handlerId);
      }
      // used for managing sounds
      this.lastActivatedBtn = handlerId;
    },
    handleUnhoverEvent(handlerId) {
      if (
        handlerId === appConstants.yesPic &&
        this.btnClasses.yesPic === appConstants.activate
      ) {
        // making the yesPic activated even if the user moved the hand out of the picture.
        return;
      }
      this.resetBtnClasses();
      this.btnClasses[handlerId] = '';
      this.lastActivatedBtn = '';
    },
    async handleActivateBack() {
      /* navigateBack is a component function, not mixins. every component will behave differently on "back" event*/
      if (this.navigateBack) {
        // this element is on CamLayOutMediator
        const soundEl = document.getElementById('back-sound');
        if (soundEl) {
          soundEl.play();
        }
        setTimeout(() => {
          this.hideUi = true; // will hide components ui. must be configured in component!
        }, appConfig.soundDelay);
        let userRes = await this.$store.getters.getAppRootServices.dialogConfirm();
        if (userRes) {
          this.navigateBack();
        }
        this.hideUi = false;
      }
    },
    mixinsImgLoadHandler(id) {
      this.activeViewId = id;
      this.itemLoaded++;
    }
  }
};
